import { useLocation } from "react-router-dom";
import { AuthImageRendering } from "./AuthImageRendering";

export const AuthFormWrapper = ({ children }) => {
  const location = useLocation();

  // const isAuthPage = [
  //   "/login",
  //   "/signup",
  //   "/forgotpassword",
  //   "/resetpassword",
  // ].includes(location.pathname);

  // if (!isAuthPage) return <>{children}</>;

  return (
    <div className="flex w-full min-h-screen ">
      {/* Left side → never scroll, always vertical center */}
      <div className="hidden md:flex md:w-full lg:w-full bg-primary-400 relative">
        {/* Glow overlay */}
        <div className="absolute inset-0 animate-pulse bg-secondary-50/30 blur-2xl pointer-events-none" />

        {/* Image container → vertical center */}
        <div className="h-screen flex justify-center items-center fixed md:left-[5%]  2xl:left-[12%]">
          <AuthImageRendering activelink={location.pathname} />
        </div>
      </div>

      {/* Right side → scrollable content */}
      <div className="w-full  bg-[#ecf1ff] overflow-y-auto">
        <div className="p-6 flex justify-center">
          <div className="w-full max-w-md">{children}</div>
        </div>
      </div>
    </div>
  );
};
